import { Guides } from "./components/guides.js";
import { OldBrowserChecker } from "./components/oldBrowserChecker.js";

/* -------------------------------------------------- */
/* 👵 Check for old browsers */
/* -------------------------------------------------- */

new OldBrowserChecker();

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides();

/* -------------------------------------------------- */
/* 📱 Mobile menu */
/* -------------------------------------------------- */

const menuToggle = document.querySelector(".menu-toggle");

if (menuToggle) {
  const menuOverlay = document.querySelector(".menu-overlay"); // native dialog element
  const closeMenuButton = menuOverlay.querySelector(
    ".menu-overlay__close-button"
  );

  menuToggle.addEventListener("click", () => {
    menuOverlay.showModal();
  });

  closeMenuButton.addEventListener("click", () => {
    menuOverlay.close();
  });

}

